var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stores-list"}},_vm._l((_vm.stores),function(store){return _c('div',{key:`store-${store.ID}`},[_c('store-details',{attrs:{"store":store}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }